export const PFX = '[HCS Console]';

export const STATUS_MESSAGE_ENABLED = `${PFX} Normal Mode Enabled`;
export const STATUS_MESSAGE_VERBOSE = `${PFX} Verbose Mode Enabled`;
export const STATUS_MESSAGE_DISABLED = `${PFX} Disabled`;

export const LOCAL_STORAGE_KEY_CONSOLE_ENABLED = 'hcs-console-enabled';
export const LOCAL_STORAGE_KEY_CONSOLE_VERBOSE = 'hcs-console-verbose';
